export default {
    setSelectedCategory(state, payload = {}) {
        state.treeSelectedItem = payload
    },

    activeAssetDetailsPlayer(state, payload = {}){
        state.activeAssetDetailsPlyr = payload
    }
};
